import React, { createRef } from 'react';
import { Button } from 'semantic-ui-react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import Modal from 'shared/components/Modal';
import CloseIcon from '@material-ui/icons/Close';
import Avatar from '@mui/material/Avatar';
import messages, { FormattedMessage } from 'shared/messages/messages';
import StoryService from 'shared/services/StoryService';
import 'semantic-ui-css/semantic.min.css';

import {
    GET_SELFIE_URL
} from 'shared/utils/Constants';

let storyService = new StoryService();

const styles = theme => ({
    form: {
        position: 'relative',
        zIndex: 2,
        width: '100%',
        background: '#fff',
        padding: '2rem 2rem',
        margin: '4vh auto 0',
        boxShadow: '3px 3px 20px rgba(0, 0, 0, 0.5)',
        maxWidth: '500px',
        borderRadius: '10px'
    },
    formBackdrop: {
        position: 'fixed',
        zIndex: 1,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5))'
    },
    closeIcon: {
        position: 'absolute',
        top: '5px',
        right: '5px',
        color: '#949494',
        opacity: 0.5,
        cursor: 'pointer',
        '&:hover': {
            opacity: 1
        }
    },
    buttonContainer: {
        textAlign: 'center',
        margin: '1em'
    },
    statusText: {
        margin: '1em'
    },
    selfieImage: {
        width: '80%',
        margin: 'auto'
    },
    videoElement: {
        width: '100%',
        transform: 'rotateY(180deg)',
        WebkitTransform: 'rotateY(180deg)', // Safari and Chrome
        MozTransform: 'rotateY(180deg)' // Firefox
    }
})

class UploadSelfieModal extends React.Component {
    constructor(props) {
        super(props);

        this.fileInput = createRef();
        this.videoRef = createRef();
        this.canvasRef = createRef();
        this.photoRef = createRef();

        this.state = {
            uploadInProgress: false,
            uploadCompleted: false,
            uploadError: false,
            imgKey: Math.random(),
            startCam: false,
            tookPhoto: false,
            hasSelfie: false,
            matchInProgress: false,
        };
    }

    componentDidMount() {
        const { loggedIn } = this.props;

        if (loggedIn) {
            this.checkSelfie();
        }
    }


    async checkSelfie() {
        var selfie = new Image();
        selfie.src = GET_SELFIE_URL(this.props.storyId);
        // selfie.crossOrigin = 'anonymous';

        selfie.onload = () => {
            this.setState({ hasSelfie: true });
        }
    }

    componentDidUpdate() {
        if (this.fileInput.current) {
            this.fileInput.current.style.position = 'absolute';
            this.fileInput.current.style.opacity = 0;
            this.fileInput.current.style.pointerEvents = 'none';
            this.fileInput.current.style.width = 0;
            this.fileInput.current.style.height = 0;
        }
    }

    uploadSelfie = event => {
        const canvas = this.canvasRef.current;

        this.setState({
            uploadInProgress: true,
            uploadCompleted: false,
            uploadError: false
        });

        if (this.state.startCam) {
            canvas.toBlob((blob) => {
                if (!blob) {
                    return;
                }

                const url = URL.createObjectURL(blob);

                fetch(url)
                    .then(res => res.blob())
                    .then(async blob => {
                        const file = new File([blob], 'dot.jpeg', blob);

                        storyService.getSelfieUploadUrl(this.props.storyId, file.type)
                            .then(resp => {
                                storyService.uploadToStorage(resp.url, file)
                                    .then(() => {
                                        this.setState({
                                            uploadInProgress: false,
                                            uploadCompleted: true,
                                            uploadError: false,
                                            imgKey: Math.random()
                                        });
                                    })
                                    .then(() => {
                                        storyService.submitSelfie(this.props.storyId);
                                    })
                                    .then(() => {
                                        this.doSelfieMatch();
                                    });
                            })
                            .catch(resp => {
                                this.setState({
                                    uploadInProgress: false,
                                    uploadCompleted: false,
                                    uploadError: true
                                });
                            });
                    })
            }, 'image/jpeg');
        } else {
            let file = event.target.files[0];

            storyService.getSelfieUploadUrl(this.props.storyId, file.type)
                .then(resp => {
                    storyService.uploadToStorage(resp.url, file)
                        .then(() => {
                            this.setState({
                                uploadInProgress: false,
                                uploadCompleted: true,
                                uploadError: false,
                                imgKey: Math.random()
                            });
                        })
                        .then(() => {
                            storyService.submitSelfie(this.props.storyId);
                        })
                        .then(() => {
                            this.doSelfieMatch();
                        });
                })
                .catch(resp => {
                    this.setState({
                        uploadInProgress: false,
                        uploadCompleted: false,
                        uploadError: true
                    });
                });
        }

    }

    renderSelfie = () => {
        const { classes, storyId } = this.props;
        return (
            <div className={classes.selfieImage}>
                <Avatar
                    key={this.state.imgKey}
                    variant="rounded"
                    src={GET_SELFIE_URL(storyId)}
                    sx={{ width: '10em', height: '10em', margin: 'auto' }}
                />
            </div>
        )
    }

    renderVideo = () => {
        const { classes, storyId } = this.props;
        return (
            <div>
                <div className={classes.selfieImage}>
                    <div hidden={this.state.tookPhoto} >
                        <video className={classes.videoElement} ref={this.videoRef} id="video">Video stream not available.</video>
                    </div>
                    <div hidden={!this.state.tookPhoto} >
                        <canvas hidden={true} ref={this.canvasRef} id="canvas"> </canvas>
                        <div class="output">
                            <img id="photo" ref={this.photoRef} alt="The screen capture will appear in this box." width="100%" />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderStatus = () => {
        const { classes } = this.props;

        let messageText;

        if (this.state.uploadInProgress) {
            messageText = <FormattedMessage {...messages.consumer_selfie_upload_in_progress} />
        } else {
            if (this.state.uploadError) {
                messageText = <FormattedMessage {...messages.consumer_selfie_upload_failed} />
            }
            if (this.state.uploadCompleted) {
                messageText = <FormattedMessage {...messages.consumer_selfie_upload_complete} />
            }
        }

        if (messageText) {
            return (
                <div className={classes.statusText}>
                    <p>{messageText}</p>
                </div>
            );
        } else {
            return null
        }
    }
    clearPhoto() {
        const canvas = this.canvasRef.current;
        const photo = this.photoRef.current;
        const context = canvas.getContext("2d");
        context.fillStyle = "#AAA";
        context.fillRect(0, 0, canvas.width, canvas.height);

        const data = canvas.toDataURL("image/png");
        photo.setAttribute("src", data);
    }

    takePicture() {
        if (this.state.tookPhoto === false) {
            this.setState({ tookPhoto: true }, () => {
                const canvas = this.canvasRef.current;
                const photo = this.photoRef.current;
                const video = this.videoRef.current;
                const width = video.videoWidth;
                const height = video.videoHeight;
                // const height = (video.videoHeight / video.videoWidth) * width;
                const context = canvas.getContext("2d");
                if (width && height) {
                    canvas.width = width;
                    canvas.height = height;
                    context.drawImage(video, 0, 0, width, height);

                    const data = canvas.toDataURL("image/jpeg");
                    photo.setAttribute("src", data);
                } else {
                    this.clearPhoto();
                }
            });
        } else {
            this.setState({
                tookPhoto: false,
                uploadInProgress: false,
                uploadCompleted: false,
                uploadError: false
            });
        }
    }

    startCam() {
        const width = 320;
        let height = 0;
        let streaming = false;

        if (this.state.startCam) {
            this.takePicture();
        } else {
            this.setState({ startCam: true }, () => {

                const video = this.videoRef.current;
                const canvas = this.canvasRef.current;
                if (video) {

                    if (this.state.startCam) {
                        navigator.mediaDevices
                            .getUserMedia({ video: true, audio: false })
                            .then((stream) => {
                                video.srcObject = stream;
                                video.play();
                            })
                            .catch((err) => {
                                console.error(`An error occurred: ${err}`);
                            });
                    }

                    video.addEventListener(
                        "canplay",
                        (ev) => {
                            if (!streaming) {
                                height = (video.videoHeight / video.videoWidth) * width;

                                video.setAttribute("width", width);
                                video.setAttribute("height", height);
                                canvas.setAttribute("width", width);
                                canvas.setAttribute("height", height);
                                streaming = true;
                            }
                        },
                        false,
                    );
                }
            });
        }
    }

    doSelfieMatch() {
        this.setState({ matchInProgress: true });
        storyService.matchSelfie(this.props.storyId).then((result) => {
            alert("Selfie Submitted");
        });
    }

    render() {
        const { classes, user, storyId } = this.props;
        let selfieText = <FormattedMessage {...messages.consumer_selfie_instructions} />
        let buttonText = <FormattedMessage {...messages.consumer_selfie_button} />
        let takeAphotoText = <FormattedMessage {...messages.consumer_take_photo_button} />
        let retakePhotoText = <FormattedMessage {...messages.consumer_retake_photo_button} />
        let searchPhotoText = <FormattedMessage {...messages.consumer_search_photo_button} />

        return (
            <Modal
                disableScrollbar={true}
                isOpen={this.props.open}
                close={this.props.onClose.bind(this)}>
                <div className={classes.formBackdrop}></div>
                <div className={classes.form}>
                    <CloseIcon className={classes.closeIcon} onClick={this.props.onClose.bind(this)} />
                    <h3>
                        {selfieText}
                    </h3>
                    {
                        this.state.startCam ? this.renderVideo() : this.renderSelfie()
                    }

                    <div className={classes.buttonContainer}>
                        {this.renderStatus()}
                        <Button onClick={() => {
                            this.setState({ startCam: false, tookPhoto: false });
                            this.fileInput.current.click();
                        }}>
                            {buttonText}
                        </Button>
                        <input type="file" accept="image/*" id="file" ref={this.fileInput} onChange={(event) => this.uploadSelfie(event)} />
                        <Button onClick={this.startCam.bind(this)}>
                            {this.state.tookPhoto ? retakePhotoText : takeAphotoText}
                        </Button>
                    </div>
                    <div className={classes.buttonContainer}>
                        {
                            this.state.tookPhoto &&
                            <Button icon='checkmark' onClick={this.uploadSelfie.bind(this)}></Button>
                        }
                        {
                            this.state.hasSelfie && !this.state.matchInProgress && !this.state.tookPhoto &&
                            <Button fluid onClick={this.doSelfieMatch.bind(this)}>{searchPhotoText}</Button>
                        }
                    </div>
                </div>
            </Modal>
        )
    }
}

const mapStateToProps = state => ({
    user: state.userReducer.user
});

const UploadSelfieComponent = withStyles(styles, { withTheme: true })(UploadSelfieModal);
export default connect(mapStateToProps, {})(UploadSelfieComponent);
